import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getOrderClassifications = async (params) => {
	const { data } = await axios.get(`${API}/admin/orders_classification`, {
		params,
	});
	return data;
};

export const getOrderClassification = async (params) => {
	const { data } = await axios.get(`${API}/admin/orders_classification/detail`, {
		params,
	});
	return data;
};

export const saveOrderClassification = async (params) => {
	const { data } = await axios.post(`${API}/admin/orders_classification/save`, params);
	return data;
};

export const deleteOrderClassification = async (params) => {
	const { data } = await axios.post(`${API}/admin/orders_classification/delete`, params);
	return data;
};
